import React from 'react'
import Navbar from '../../../Components/Navbar/Navbar'
import Herorp from './Herorp'
import Refund_Policy_Contentss from './Refund_Policy_Content'
import Footer from '../../../Components/Footer/Footer';

const Refund_Policy = () => {
  return (
    <div>
        <Navbar></Navbar>
        <Herorp></Herorp>
        <Refund_Policy_Contentss></Refund_Policy_Contentss>
        <Footer></Footer>
        
    </div>
  )
}

export default Refund_Policy